import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 40px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
            <div className="col-md-7">
            <div className="pq-section pq-style-1 text-center">
               <h2 className="pq-section-title">Frequently Asked Questions (FAQ’s)</h2>
            </div>
            <div className="col-xl-12 mt-xl-0 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {[ 
                  { question: "What are the common causes of vertigo?", answer: "Vertigo can be caused by inner ear problems such as BPPV (Benign Paroxysmal Positional Vertigo), vestibular neuritis, Ménière’s disease, ear infections, migraines, neck issues, or imbalance disorders. A proper ENT evaluation helps identify the exact cause and plan the right treatment." },
                  { question: "How is vertigo diagnosed by an ENT specialist?", answer: "Diagnosis includes a detailed medical history, balance tests, positional tests like the Dix-Hallpike test, hearing evaluation, and sometimes imaging like MRI or CT scan. These help determine whether the vertigo is due to inner ear issues or other neurological causes." },
                  { question: "What treatments are available for vertigo?", answer: "Treatment depends on the cause and may include repositioning maneuvers (like Epley), medications for dizziness and nausea, vestibular rehabilitation therapy (VRT), lifestyle changes, or treating underlying ear infections or migraine triggers. Most patients improve significantly with the right treatment plan." },
                  {question: " How much does vertigo treatment cost in Delhi?", answer: "Vertigo treatment cost varies depending on tests and procedures needed. Basic consultation starts around ₹800–₹1500. Diagnostic tests like audiometry, vestibular tests, or imaging cost extra. Repositioning maneuvers are usually affordable and often give instant relief. The total cost depends on severity and required treatment."},
                  {question: "When should I see a doctor for vertigo?", answer: "You should visit an ENT specialist if vertigo is frequent, lasts more than a few minutes, affects balance, is associated with hearing loss, ringing in the ears, or nausea. Sudden severe vertigo with headache or vision changes needs urgent medical attention. Early treatment prevents symptoms from worsening."}
                ].map((item, index) => (
                  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                      <h4 className="ad-title-text">
                        {item.question}
                        <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                      </h4>
                    </div>
                    <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                      <p className="pq-detail-text">{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
             </div>
            <div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                     <iframe width="100%" height="315" src="https://www.youtube.com/embed/CaiAaBGNZBs?si=MkIohwL_pl6AeArS" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  <div class="p-3"><h5 class="text-success mb-0">Vertigo Symptoms| वर्टिगो क्या है? कारण, लक्षण और इलाज</h5></div>
          </div>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
}
